import * as types from './mutation-types'
import {LOAD_TEMPLATE_KEY} from "./mutation-types";

export default {
  [types.LOAD_EVENT_STATUS_ENUM](state, data) {
    state.eventStatusEnum = data
  },

  [types.LOAD_EVENT_INSCRIPTION_STATUS](state, data) {
      state.inscriptionStatusEnum = data
  },

  [types.LOAD_EVENT_STATUS](state, data) {
    state.eventStatus = data.data
  },

  [types.LOAD_EVENT_PARTICIPATOR_TYPE](state, data) {
    state.eventTypes = data
  },

   [types.LOAD_EVENT_VALIDATED_PARTICIPATORS](state, data) {
    state.validatedParticipators = data
  },

  [types.SET_CURRENT_EVENT](state, data) {
    state.currentEvent = data
  },

  [types.LOAD_EVENT_PERMISSIONS](state, data) {
    state.eventPermissions = data
  },

  [types.LOAD_EVENT_PARTICIPATORS](state, data) {
    state.participators = data.data
  },

  [types.LOAD_VARIABLES](state, data) {
    state.variables = data
  },

  [types.LOAD_EVENT_INVITATION_STATUS](state, data) {
    state.invitationStatus = data
  },

  [types.LOAD_TEMPLATE_KEY](state, data) {
    state.templateKey = data.key
  },
  [types.SET_CURRENT_INVITATION](state,data) {
    state.currentInvitation = data
  }
}
